module.exports = __webpack_public_path__ + "img/p11.66432fa1.jpg";